module.exports = __webpack_public_path__ + "static/media/play-video-button.180709a6.svg";